import { Grid } from "@mui/material";
import { useCallback } from "react";
import { Edit, SaveButton, SimpleForm, Toolbar, useNotify, useRecordContext, useRedirect } from "react-admin";
import { useForm } from "react-final-form";
import dataProvider from "../../dataProvider";
import { SubCategoryTagSelect } from "./components/subcat-tag-select";

export const FilteringOverwriteCreate = (props) => {
  return (
    <>
      <Edit {...props}>
        <Edit2 />
      </Edit>
    </>
  );
};

const Edit2 = () => {
  return (
    <>
      <SimpleForm toolbar={<CustomToolbar />}>
        <Grid container>
          <Grid item sm={12} md={12}>
            <SubCategoryTagSelect />
          </Grid>
        </Grid>
      </SimpleForm>
    </>
  );
};

const CustomToolbar = () => {
  const record = useRecordContext();
  const form = useForm();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmitWithRedirect = useCallback(async () => {
    const values = form.getState().values;

    try {
      await dataProvider.createSubcatFilterOverwrite({
        data: values,
      });

      redirect("edit", "/subcat-filter-overwrite-list", record.id);
    } catch (error) {
      notify(error.message.toString(), "warning");
    }
  });

  return (
    <Toolbar>
      <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} />
    </Toolbar>
  );
};
